<template>
  <b-card class="border-none">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT SERVICE DETAILS
      </h6>
      <EditDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="tableData"
      border
    >
      <el-table-column
        label="Title"
        min-width="250px"
        prop="title"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Edited By" prop="editedby" sortable>
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
          <p class="font-semibold text-left name mb-0 text-sm" v-else>-</p>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Description"
        min-width="250px"
        prop="Description"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column> -->

      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card-footer>
    <!-- <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer> -->
  </b-card>
</template>
<script>
import projects from "./projects";
import { mapState } from "vuex";
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      projects,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      perPage: 10,
      totalRows: 0,
      search: "",
      tableData: [],
    };
  },
  watch: {
    async currentPage() {
      await this.getallServices();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.currentPage = 1;
        await this.getallServices();
      }, 500),
    },
  },
  methods: {
    async getallServices() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        let loader = this.$loading();
        const getServices = await this.$store.dispatch(
          "services/get_all",
          payload
        );
        // console.log(getServices);
        loader.close();
        this.totalRows = this.get_AllService.totalCount;
        let servicesData = this.get_AllService.result;
        this.tableData = servicesData;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$router.push({ name: "social-admin-edit-exclusive" });
      await this.$store.commit("services/SELECT_Service", row);
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { _id: row._id };
      let loader = this.$loading();
      try {
        let deleteData = await this.$store.dispatch("services/delete", payload);

        if (deleteData.code === 200) {
          // console.log("delete");
          await this.getallServices();
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("services", { get_AllService: "get_AllService" }),

    // displayedPages() {
    //   return this.get_AllService.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    // totalPages() {
    //   return this.get_AllService.length;
    // },
  },
  async mounted() {
    await this.getallServices();
  },
};
</script>
<style>
.card-body {
  padding: 1.5rem 0.5rem;
}
</style>
